module.exports = __webpack_public_path__ + "img/List.b38933b6.svg";